
export const PipesGradeData=[
  {
  id:1,
  grade:"SS Pipes/tubes",
  link:'/SSPipes',                           

},
{
  id:2,
  grade:"Inconel Pipes/tubes",
  link:'/InconelPipes',

},
{
  id:3,
  grade:"Monel  Pipes/tubes",
  link:'/MonelPipes',

  
},
{
  id:4,
  grade:"NICKEL Pipes/tubes",
  link:'/NickelPipes',

  
},
{
  id:6,

  grade:"TITANIUM Pipes/tubes",
  link:'/titaniumPipes',

  
},

{
  id:10,
  grade:"Hastelloy Pipes/tubes",
  link:'/HastelloyPipes',

  
},

{
  id:12,

  grade:"Duplex Superduplex Pipes/tubes",
  link:'/DuplexSuperduplexPipes',

  
},
]





export const SSPipesData = [
  {
    text1:
      "Stainless Steel Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Stainless Steel Capillary Tubes Manufacturer In India, High Quality Precision Tubes Supplier, Exporter, Electropolished Capillary Tubes, Ss304 Capillary Tubes, Ss304l Capillary Tubes, Ss316l Capillary Tubes, Precision Tubes, Capillary Tubing Supplier In India, Bright Polished, Cleaned, Passivated Capillary Tubing",
    text3:
      "These Stainless steel channels are Certified by Third Party Inspection Accepted by EN 10204 3.2, PED 97/23/EC by Lloyd's, NABL test kept up, 3.1 Mill TC, ASME Boiler and Pressure Vessel Code Certificated Certificate Issued by TUV or as appeared by client fundamentals.",
    Specifications: {
      Grade: "310S, 321,304/ 304L, 316L, 309, etc",
      "O.D:": "0.3 –12.0 mm",
      "W.T": "0.08 – 0.2 mm",
      Length: "As for your requirement",
      Standard: "ASTM, GB, AISI, JIS, DIN, etc",
      "Delivery Time": "10~50 days ,according to customer's quantity",
      "Delivery Condition":
        "Pickled, polished, bright annealed, electrolytic polished",
      "Package: ": "Plastic bag for each bundle or as for your requirement.",
      RANGE: "0.35mm to 6.35mm OD in thickness ranging from 0.1mm to 1.2mm.",
    },
    chemical: {},
  },
];

export const InconelPipesData = [
  {
    text1:
      "Inconel Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "The Modi Metals Stocks, Manufacturers and Exports Inconel composite 600,601, 625 and X750 tight pipes and chambers near to Inconel compound 600,601, 625 and X750 unsurprising and welded channels, Inconel mix 600,601, 625 and X750 heat exchanger tubes, Inconel amalgam 600,601, 625 and X750 finned pipes and chambers, Inconel blend 600,601, 625 and X750 U tubes in extents of ASTM B161 - ASME SB161, ASTM B165 - ASME SB165, ASTM B167 - ASME SB167, ASTM B407 - ASME SB407, ASTM B423 - ASME SB423, ASTM B622 - ASME SB622, ASTM B725 - ASME SB725, ASTM A165 - ASME SB165, ASTM B619 - ASME SB619 as demonstrated by ASME B36.10 & ASME B36.19",
    text3:
      "Fine Tubes are portrayed by tight insurances, and inside surface of the chambers is free from oil, oil and different particles. Victor Steel Corporation are one of the prominent producer, exporter and provider of Capillary Tubes that are made by standard nature of grungy materials. It can provide guidance to the fluid in slim spaces kept from verifying the help of, and in addition against outside powers like gravity. Everything considered, this happens in light of intermolecular powers amidst the fluid that incorporate strong surfaces.",
    Specifications: {
      Specifications: "ASTM, ASME, DIN, NFA, JIS",
      Size: "9.52 mm O.D to 50.80 mm O.D",
      "Thickness ": "0.7 mm to 3.68 mm",
      Schedules: "SCH. 5, 10, 20, 30, 40, 60, 80, 100, 120, 140, 160, XXS.",
      "Length ": "Single Random, Double Random & Required Length",
      Form: "Round Pipes/Tubes, Square Pipes/Tubes, Rectangular Pipe/Tubes, Coiled Tubes, “U” Shape, Pan Cake Coils, Hydraulic Tubes",
      "End ": "Plain End, Beveled En",
      Grade: "Inconel 600,601,625,X750",
    },
    chemical: {},
  },
];

export const MonelPipesData = [
  {
    text1:
      "Monel Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "The Modi Metals Stocks, Manufacturers and Exports Monel amalgam 400, K500 thin pipes and chambers close by Monel compound 400, K500 steady and welded channels, Monel composite 400, K500 heat exchanger tubes, Monel blend 400, K500 finned pipes and chambers, Monel mix 400, K500 U tubes in checks of ASTM B161 - ASME SB161, ASTM B165 - ASME SB165, ASTM B167 - ASME SB167, ASTM B407 - ASME SB407, ASTM B423 - ASME SB423, ASTM B622 - ASME SB622, ASTM B725 - ASME SB725, ASTM A165 - ASME SB165, ASTM B619 - ASME SB619 as appeared by ASME B36.10 & ASME B36.19.",
    text3:
      "We offer sublime monel tubes with intrinsic affirmation from separating and high bore. These chambers are perfect for use in marine applications and pitiless current conditions. Our level of monel chambers are available in different outside estimation as indicated by the essentials of the clients.",
    Specifications: {
      Specifications: "ASTM, ASME and API",
      Range: "6.35 mm OD upto 254 mm OD in 0.6 TO 20 mm thickness.",
      Size: '15"NB TO 150"NB IN',
      "Thickness ": "0.7 mm to 3.68 mm",
      Schedules: "SCH. 5, 10, 20, 30, 40, 60, 80, 100, 120, 140, 160, XXS.",
      "Length ": "Double Random, Single Random, Cut Length",
      Form: "Round Pipes/Tubes, Square Pipes/Tubes, Rectangular Pipe/Tubes, Coiled Tubes, “U” Shape, Pan Cake Coils, Hydraulic Tubes",
      "End ": "Plain End, Beveled En",
      Grade: "Monel 400,Monel K500",
      Types: "Seamless / ERW / Welded / Fabricated / CDW",
    },
    chemical: {},
  },
];
export const NickelPipesData = [
  {
    text1:
      "Nickel Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "The Modi Metals. Stocks, Manufacturers and Exports Nickel mix 200, 201 and 205 tight pipes and chambers near to Nickel compound 200,201 and 205 unsurprising and welded channels, Nickel amalgam 200,201 and 205 warmth exchanger tubes, Nickel composite 200,201 and 205 finned pipes and chambers, Nickel composite 200,201 and 205 U tubes in principles of ASTM B161 - ASME SB161, ASTM B165 - ASME SB165, ASTM B167 - ASME SB167, ASTM B407 - ASME SB407, ASTM B423 - ASME SB423, ASTM B622 - ASME SB622, ASTM B725 - ASME SB725, ASTM A165 - ASME SB165, ASTM B619 - ASME SB619 as demonstrated by ASME B36.10 & ASME B36.19",
    text3:
      'The appraisal of these Nickel blend chambers Nickel, The size in consistent is from ½" to 10" and welded is from ½" to 48". Its sorts look like CDW, ERW, relentless, welded and manufactured. Its structures are flapjack hover, round, rectangular, square, U-shape, and water filled load. Long, it is accessible as single and twofold capricious and cut length. Its fruitions are plain, wandered and slanted. Basically give your affirmation needs and get it from solid exporter at simple to bear the cost of costs.',
    Specifications: {
      Specifications: "ASTM, ASME and API",
      Range: "6.35 mm OD upto 254 mm OD in 0.6 TO 20 mm thickness.",
      Size: 'Seamless 1/2" - 10", Welded 1/2" - 48"',
      "Thickness ": "0.7 mm to 3.68 mm",
      Schedules: "SCH. 5, 10, 20, 30, 40, 60, 80, 100, 120, 140, 160, XXS.",
      "Length ": "Double Random, Single Random, Cut Length",
      Form: "Round, Rectangular, Hydraulic, Square",
      "End ": "Plain End, Beveled En",
      Grade: "Nickel 200,201,L605,MP35N,48,52",
      Types: "Seamless / ERW / Welded / Fabricated / CDW",
    },
    chemical: {},
  },
];

export const TitaniumPipesData = [
  {
    text1:
      "Titanium Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "The Modi Metals. Stocks, Manufacturers and Exports Titanium Gr2, Gr5, Gr7, Gr9 hairlike pipes and cylinders alongside Titanium Gr2, Gr5, Gr7, Gr9 consistent and welded channels, Titanium Gr2, Gr5, Gr7, Gr9 heat exchanger tubes, Titanium Gr2, Gr5, Gr7, Gr9 finned pipes and cylinders, Titanium Gr2, Gr5, Gr7, Gr9 U tubes in models of ASTM B265, ASTM B337, ASTM B338, ASTM B348, ASTM B381, ASTM F67, ASTM B265, ASTM B337, ASTM B338, ASTM B348, ASTM B265, ASTM F467, ASTM F468, AMS 4900, AMS 4901, AMS 4902, AMS 4940, AMS 4941, AMS 4942, AMS Mil T-9046, AMS 4943, AMS 4944, AMS 4945, AMS 9047, AMS 4906, AMS 4911, AMS 4920, AMS 4928, AMS 4935.",
    text3:
      'The appraisal of these Titanium blend chambers Titanium, The size in consistent is from ½" to 10" and welded is from ½" to 48". Its sorts look like CDW, ERW, relentless, welded and manufactured. Its structures are flapjack hover, round, rectangular, square, U-shape, and water filled load. Long, it is accessible as single and twofold capricious and cut length. Its fruitions are plain, wandered and slanted. Basically give your affirmation needs and get it from solid exporter at simple to bear the cost of costs.',
    Specifications: {
      Specifications: "ASTM, ASME",
      Range: "6.35 mm OD upto 254 mm OD in 0.6 TO 20 mm thickness.",
      Size: "½”NB to 24”NB in Sch 10s, 40s, 80s, 160s, XXS.",
      "Thickness ": "0.7 mm to 3.68 mm",
      Schedules:
        "SCH 40, SCH 80, SCH 160, SCH XS, SCH XXS, All Schedules, upto 12mm thk",
      "Length ": "Double Random, Single Random, Cut Length",
      Form: "Round, Rectangular, Hydraulic, Square",
      "End ": "Plain End, Beveled En",
      Grade: "Titanium Gr.2,Gr5,Gr.7,Gr.9",
      Types: "Seamless / ERW / Welded / Fabricated / CDW",
    },
    chemical: {},
  },
];

export const HastelloyPipesData = [
  {
    text1:
      " Hastelloy Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      " The Modi Metals. Stocks, Manufacturers and Exports Hastelloy composite B2,C22,C263 and C276 confined pipes and chambers close-by Hastelloy compound B2,C22,C263 and C276 unwavering and welded channels, Hastelloy amalgam B2,C22,C263 and C276 heat exchanger tubes, Hastelloy blend B2,C22,C263 and C276 finned pipes and chambers, Hastelloy mix B2,C22,C263 and C276 U tubes in models of ASTM B161 - ASME SB161, ASTM B165 - ASME SB165, ASTM B167 - ASME SB167, ASTM B407 - ASME SB407, ASTM B423 - ASME SB423, ASTM B622 - ASME SB622, ASTM B725 - ASME SB725, ASTM A165 - ASME SB165, ASTM B619 - ASME SB619 as shown by ASME B36.10 & ASME B36.19.",
    text3:
      "We secure hastelloy materials from Special Metals, Eagle Alloys and diverse other maker of Hastelloy Tubing. We in like manner see worth included relationship for hastelloy Forging, Hastelloy throwing and hastelloy welding. We are likewise shipper of scrap in all evaluations of hastelloy amalgam.",
    Specifications: {
      Specifications: ": ASTM B619, B622 / ASME SB619, SB622",
      Range: "6.35 mm OD upto 254 mm OD in 0.6 TO 20 mm thickness.",
      Size: " 15 NB to 150 NB IN",
      "Thickness ": ' 035" –.095′,',
      Schedules: " SCH5, SCH10, SCH40, STD, SCH80, SCH160",
      "Length ": "Double Random, Single Random, Cut Length",
      Form: "Round, Rectangular, Hydraulic, Square",
      "End ": "Plain End, Beveled En",
      Grade: "Hastelloy C22,Hastelloy C276,Hastelloy B2,Hastelloy C263 ",
      Types: "Seamless / ERW / Welded / Fabricated / CDW",
    },
    chemical: {},
  },
];

export const DuplexPipesData = [
  {
    text1:
      "Duplex & Superduplex Capilary Tube Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      'We segment Duplex Steel Capillary chambers and pipes in Grades, for example, Duplex Steel 2101 LDX (1.4162/S32101), Duplex Steel DX2202 (1.4062/S32202), Duplex Steel 2304 (1.4362/S32304), Duplex Steel 2205 (1.4462/S31803/S32205). These Duplex Steel channels & Tubes have high chromium (19–28%) and molybdenum (up to 5%) with lower nickel substance than austenitic tempered steels. We even Stock and Export Seamless and welded Duplex Steel channels and chambers, Finned Duplex Steel channels, Heat exchanger Duplex Steel pipes and chambers and Duplex Steel instrumentation chambers and pipes. These Duplex Steel Capillary channels are unguarded with Outside Diameter from 0.25mm (0.010") up to 16.00mm (0.625"), divider thickness going 0.05mm (0.002") up to 1.00mm (0.040"), Straight Lengths of 1.00mm (0.040") up to 5000.00mm (197") and Coils Lengths of 5 Meters to 15 Meters. Our Capillary Duplex Steel channels and chambers are outfitted with Standard Tolerance of OD &ID +/ - 0.03mm (0.0012") Wall +/ - 10% and Tight Tolerance - OD&ID +/ - 0.015mm (0.0006") Wall +/ - 3%.',
    text3:
      "Duplex Steel channels and chambers are unguarded with us as showed up by ASTM A789 Standard Specification for Seamless and Welded Ferritic/Austenitic Stainless Steel Tubing for General Service, ASTM A790 (ASME SA790) Standard Specification for Seamless and Welded Ferritic/Austenitic Stainless Steel Pipe and ASTM A928 (ASME SA928) Standard Specification for Ferritic/Austenitic (Duplex) Stainless Steel Pipe Electric Fusion Welded with Addition of Filler Metal. These duplex Steel 2205 channels are Certified by Third Party Inspection Accepted by EN 10204 3.2, PED 97/23/EC by Lloyd's, ASME Boiler and Pressure Vessel Code Certificated Certificate Issued by TUV or according to client necessities",
    Specifications: {
      Specifications: ": BS, DIN, ANFOR, UNI, AND JIS EQUIVALENTS",
      Range: " 1/16″ (1.59 mm) to 4″ (101.6 mm)",
      Size: " 0.010″ (0.25 mm) to 0.220″ (5.59 mm)",
      "Thickness ": ' 035" –.095′,',
      Schedules: " SCH5, SCH10, SCH40, STD, SCH80, SCH160",
      "Length ": "Double Random, Single Random, Cut Length",
      Form: "Round, Rectangular, Hydraulic, Square",
      "End ": "Plain End, Beveled En",
      Grade: "Duplex 2205 ,Superduplex 2507",
      Types: "Seamless / ERW / Welded / Fabricated / CDW",
    },
    chemical: {},
  },
];
